<template>
  <v-container class="forgot">
    <div v-if="emailSent">
      <v-row align="center">
        <v-col>
          <h3>
            If an email was found associated with the supplied address, a reset
            password email has been sent. Please respond to this one time use
            invitation within 24 hours to change your password.
          </h3>
        </v-col>
      </v-row>
    </div>
    <div v-else class="formcontainer">
      <v-row no-gutters>
        <v-col align="center">
          <h1>Please enter the email associated with your account.</h1>
        </v-col>
      </v-row>
      <v-form
        ref="confirmEmailForm"
        @submit.prevent="confirmEmailClick"
        v-model="valid"
      >
        <v-row>
          <v-col>
            <v-text-field
              type="text"
              outlined
              placeholder="Email"
              v-model="email"
              :rules="emailRules"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              :disabled="!valid"
              :loading="btnLoading"
              @click="confirmEmailClick"
              outlined
              >Confirm</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
    <v-row>
      <v-col>
        <v-btn @click="backToLogin" outlined>Back</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "ForgotPasswordSelf",
  data() {
    return {
      valid: true,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "Must be valid E-mail",
      ],
      btnLoading: false,
    };
  },
  computed: {
    emailSent() {
      return this.$store.getters["forgot/getEmailSent"];
    },
  },
  methods: {
    confirmEmailClick() {
      this.$refs.confirmEmailForm.validate();
      if (this.valid) {
        this.btnLoading = true;
        this.$store
          .dispatch("forgot/postForgotPassword", {
            userId: this.email,
          })
          .then(() => {
            this.$store.dispatch("forgot/setEmailSent", true).then(() => {
              this.btnLoading = false;
            });
          });
      }
    },
    backToLogin() {
      this.email = "";
      this.$store.dispatch("forgot/reset").then(() => {
        this.$router.push("/login");
      });
    },
  },
  mounted() {
    this.email = "";
  },
};
</script>

<style scoped>
.forgot .formcontainer .v-btn {
  box-shadow: 3px 3px;
  width: 100%;
}

.forgot .v-btn {
  width: 75%;
  box-shadow: 3px 3px;
}

.forgot h1,
h3 {
  color: #51a684;
}

.forgot {
  max-width: 800px;
}

.forgot .form {
  max-width: 75%;
}

.forgot .formcontainer {
  margin-top: 3vh;
  max-width: 75%;
  margin-left: auto;
  margin-right: auto;
}
</style>
